<template>
  <v-row justify="center">
    <v-dialog
      v-model="isVisible"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      max-width="480"
      persistent
      scrollable
    >
      <v-card color="brand-card-bg">
        <v-toolbar
          color="brand-card-bg"
          flat
          height="80"
          max-height="80"
        >
          <v-toolbar-title class="pl-3">
            <div class="brand-text-title">
              {{ toLocaleUpperCase($t('Tag.SelectTagDialog.Title')) }}
            </div>
            <div class="brand-text-small">
              {{ $t('Tag.SelectTagDialog.Subtitle') }}
            </div>
          </v-toolbar-title>

          <v-spacer />

          <v-btn
            class="ma-0"
            color="brand-green-dark"
            icon
            outlined
            style="background-color: white"
            @click="onCancelButtonClick"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-divider class="mx-6 brand-green-dark" />

        <v-card-text class="pa-2">
          <v-container fluid>
            <v-row dense>
              <v-col cols="12">
                <v-list
                  class="pa-0"
                  color="transparent"
                >
                  <template v-for="(tag, idx) in tags">
                    <template v-if="tag.Visible">
                      <v-list-item
                        :key="`list-item-${idx}`"
                        class="brand-beige mb-2 px-3"
                        ripple
                        @click="onTagSelected(tag)"
                      >
                        <v-list-item-avatar
                          :color="tag.Color"
                          size="40"
                          style="border: var(--v-brand-green-dark-base) solid 1px;"
                        >
                          <v-icon :color="getContrastColor(tag.Color, 168) === 'black' ? 'black' : 'white'">
                            {{ tag.Icon }}
                          </v-icon>
                        </v-list-item-avatar>

                        <v-list-item-content>
                          <v-list-item-title class="text-left">
                            <h3 class="text-body mt-1">
                              {{ getTranslatedField(tag, 'Label') }}
                            </h3>
                          </v-list-item-title>

                          <v-list-item-subtitle v-if="getTranslatedField(tag, 'Description')">
                            <span class="brand-text-small brand-grey--text">
                              {{ getTranslatedField(tag, 'Description') }}
                            </span>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </template>
                </v-list>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import SelectTagDialogMixin from '@/theme/default/views/tag/SelectTagDialog.js'

export default {
  name  : 'SelectTagDialog',
  mixins: [SelectTagDialogMixin]
}
</script>

<style scoped src="@/theme/default/views/tag/SelectTagDialog.css"></style>
<style scoped>
</style>
